import React, { ReactNode } from 'react';

import { Pagination as PaginationCore } from 'antd';

interface IPagination {
	className?: string;
	defaultPage?: number;
	currentPage?: number;
	totalRows: number;
	pageSize?: number;
	onPageChange?: (page: number, pageSize: number) => void;
	itemRender?: (page: number, type: string) => ReactNode;
}

const Pagination = ({
	className,
	defaultPage = 1,
	currentPage = 1,
	totalRows = -1,
	pageSize = 10,
	onPageChange,
	itemRender,
}: IPagination) => {
	return (
		<PaginationCore
			className={className}
			showSizeChanger={false}
			defaultCurrent={defaultPage}
			current={currentPage}
			total={totalRows}
			pageSize={pageSize}
			onChange={onPageChange}
			itemRender={itemRender}
		/>
	);
};

export default Pagination;
